import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { GestionAfiliadoService } from '../../services/gestionafiliado.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { GestionAfiliado_Parametro } from '../../models/generic/GestionAfiliado_Parametro';
import { GestionAfiliado_DatosAdicionales } from 'src/app/models/generic/GestionAfiliado_DatosAdicionales';
import { MatTableDataSource } from '@angular/material/table';
import { GestionAfiliado_DatosAdicionales_Retorno } from 'src/app/models/generic/GestionAfiliado_DatosAdicionales_Retorno';
import { GestionAfiliado } from 'src/app/models/generic/GestionAfiliado';
import { Constantes } from 'src/app/models/modules/Constantes';
import { GestionAfiliado_Detalle } from 'src/app/models/generic/GestionAfiliado_Detalle';
import { GestionAfiliado_Movimientos } from 'src/app/models/generic/GestionAfiliado_Movimientos';
import { GestionAfiliado_DocumentosConsulta } from 'src/app/models/generic/GestionAfiliado_DocumentosConsulta';

@Component({
  selector: 'gestion-afiliados-detalle',
  templateUrl: './gestion-afiliados-detalle.component.html',
  styleUrls: ['./gestion-afiliados-detalle.component.scss']
})
export class GestionAfiliadosDetalleComponent implements OnInit{
  
  tipoRetorno: string = '';
  parametroAdicionalTipoRetorno: string = '';
  form: FormGroup;
  formDatosAdicionales: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  parametrosPrincipal: GestionAfiliado_Parametro;
  gestionAfiliado_DatosAdicionales: GestionAfiliado_DatosAdicionales_Retorno;
  consultoDatos: boolean = false;

  dataSourceDatosMovimientos: MatTableDataSource<any>;
  listaDatosMovimientos: any[] = [];
  columnasEncabezadoMovimientos: string[] = ['id', 'fecha', 'operacion', 'expediente', 'registro', 'cierre'];

  dataSourceDatosAdicionales: MatTableDataSource<any>;
  listaDatosAdicionales: any[] = [];
  columnasEncabezadoDatosAdicionales1: string[] = [];
  columnasEncabezadoDatosAdicionales2: string[] = [];

  dataSourceBeneficiarios: MatTableDataSource<any>;
  listaBeneficiarios: any[] = [];
  columnasEncabezadoBeneficiarios: string[] = [];

  dataSourceDatosDocumentos: MatTableDataSource<GestionAfiliado_DocumentosConsulta>;
  listaDatosDocumentos: GestionAfiliado_DocumentosConsulta[] = [];
  columnasEncabezadoDocumentos: string[] = ['nro', 'fotografia', 'archivo'];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public gestionAfiliadoService: GestionAfiliadoService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
    
    this.form.get('nroDocumento').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroDocumento);
    this.form.get('nombresApellidos').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nombresApellidos);
    this.form.get('fechaAfiliacion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].fechaAfiliacion);
    this.form.get('activo').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].activo);
    this.form.get('idProducto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProducto);
    this.form.get('producto').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].producto);
    this.form.get('estado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estado);
    this.form.get('estadoColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoColor);
    this.form.get('estadoDescripcion').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcion);
    this.form.get('estadoDescripcionColor').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].estadoDescripcionColor);
    this.form.get('edad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].edad);
    this.form.get('idEstado').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idEstado);
    this.form.get('idProductoEdad').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoEdad);
    this.form.get('nroPoliza').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].nroPoliza);
    this.form.get('idProductoUnico').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].idProductoUnico);
    this.form.get('rutaTerminosCondiciones').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].rutaTerminosCondiciones);
    this.form.get('rutaControlOperaciones').setValue(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0].rutaControlOperaciones);
    this.tipoRetorno = this.parametrosPrincipal.tipoRetorno;
    this.parametroAdicionalTipoRetorno = this.parametrosPrincipal.parametroAdicionalTipoRetorno;

    this.ConsultarGestionAfiliadoDetalle();
    this.ConsultarGestionAfiliadoMovimientos();
    this.ConsultarGestionAfiliadoDocumentos();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      nroDocumento: [''],
      nombresApellidos: [''],
      fechaAfiliacion: [new Date()],
      activo: [false],
      mostrarBeneficiarios: [false],
      idProducto: [0],
      producto: [''],
      estado: [''],
      estadoColor: [''],
      estadoDescripcion: [''],
      estadoDescripcionColor: [''],
      edad: [0],
      idEstado: [0],
      idProductoEdad: [0],
      nroPoliza: [''],
      idProductoUnico: [0],
      rutaTerminosCondiciones: [''],
      rutaControlOperaciones: [''],
    });

    this.formDatosAdicionales = this.fb.group({
      filtro: ['']
    });
  }
  CancelarRegistro() {
    if (this.tipoRetorno === 'EXPEDIENTES') {
      this.menuService.CambiarComponenteActivo('ExpedientesDetalleComponent', this.parametroAdicionalTipoRetorno);
    } else {
      this.menuService.CambiarComponenteActivo('GestionAfiliadosComponent', JSON.stringify(this.parametrosPrincipal));
    }
  }
  ConsultarGestionAfiliadoDetalle() {
    this.consultoDatos = false;
    this.mostrarCargando = true;
    this.gestionAfiliadoService.ConsultarDatosAdicionales(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0])
                .subscribe((resp: GestionAfiliado_DatosAdicionales_Retorno) =>{
                  this.gestionAfiliado_DatosAdicionales = resp;
                  this.form.get('mostrarBeneficiarios').setValue(this.gestionAfiliado_DatosAdicionales.mostrarBeneficiarios);

                  this.CrearDataSourceClientes();
                  this.consultoDatos = true;
                  this.mostrarCargando = false;

                  if (this.form.get('mostrarBeneficiarios').value) {
                    this.listaBeneficiarios = JSON.parse(resp.listaDatosBeneficiarios);
                    this.columnasEncabezadoBeneficiarios = resp.listaCamposBeneficiarios;
                    this.recargarListaBeneficiarios();
                  }
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  ConsultarGestionAfiliadoMovimientos() {
    this.consultoDatos = false;
    this.mostrarCargando = true;
    this.gestionAfiliadoService.ConsultarMovimientos(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0])
                .subscribe((resp: GestionAfiliado_Movimientos[]) =>{
                  this.listaDatosMovimientos = resp;
                  this.recargarListaMovimientos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  recargarListaMovimientos() {
    this.dataSourceDatosMovimientos = new MatTableDataSource(this.listaDatosMovimientos);
    this.dataSourceDatosMovimientos.paginator = this.paginator;
    this.dataSourceDatosMovimientos.sort = this.sort;
  }
  ConsultarGestionAfiliadoDocumentos() {
    this.consultoDatos = false;
    this.mostrarCargando = true;
    this.gestionAfiliadoService.ConsultarDocumentos(this.parametrosPrincipal.gestionAfiliado_Seleccionado[0])
                .subscribe((resp: GestionAfiliado_DocumentosConsulta[]) =>{
                  this.listaDatosDocumentos = resp;
                  for (let index = 0; index < this.listaDatosDocumentos.length; index++) {
                    let item = this.listaDatosDocumentos[index];
                    item.contador = index + 1;
                  }

                  this.listaDatosDocumentos = this.listaDatosDocumentos.sort((a, b) => b.contador - a.contador)

                  this.recargarListaDocumentos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
  }
  recargarListaDocumentos() {
    this.dataSourceDatosDocumentos = new MatTableDataSource(this.listaDatosDocumentos);
    this.dataSourceDatosDocumentos.paginator = this.paginator;
    this.dataSourceDatosDocumentos.sort = this.sort;
  }
  CrearDataSourceClientes() {
    this.columnasEncabezadoDatosAdicionales1 = this.gestionAfiliado_DatosAdicionales.listaCampos1;
    this.columnasEncabezadoDatosAdicionales2 = this.gestionAfiliado_DatosAdicionales.listaCampos2;
    this.listaDatosAdicionales = JSON.parse(this.gestionAfiliado_DatosAdicionales.listaDatos);
    
    this.recargarLista();
  }
  recargarLista() {
    this.dataSourceDatosAdicionales = new MatTableDataSource(this.listaDatosAdicionales);
    this.dataSourceDatosAdicionales.paginator = this.paginator;
    this.dataSourceDatosAdicionales.sort = this.sort;
  }
  recargarListaBeneficiarios() {
    this.dataSourceBeneficiarios = new MatTableDataSource(this.listaBeneficiarios);
    this.dataSourceBeneficiarios.paginator = this.paginator;
    this.dataSourceBeneficiarios.sort = this.sort;
  }
  MostrarTerminosCondiciones(): boolean {
    return this.utilitariosService.VerificarContieneDatosTexto(this.form.get('rutaTerminosCondiciones').value);
  }
  MostrarControlOperaciones(): boolean {
    return this.utilitariosService.VerificarContieneDatosTexto(this.form.get('rutaControlOperaciones').value);
  }
  MostrarEdad() {
    return this.utilitariosService.VerificarContieneDatosTexto(this.form.get('edad').value);
  }
  TieneDocumentosAjuntos(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listaDatosDocumentos)) {
      return true;
    }
    return false;
  }
  DescargarDocumento(itemSeleccionado: GestionAfiliado_DocumentosConsulta) {
    this.mostrarCargando = true;
      this.gestionAfiliadoService.DescargarDocumento(itemSeleccionado)
      .subscribe((resp: any) =>{
        let nombreArchivoDescarga: string = itemSeleccionado.nombre;

        let dataType = resp.type;
        let binaryData = [];
        binaryData.push(resp);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', nombreArchivoDescarga);
        document.body.appendChild(downloadLink);
        downloadLink.click();

        this.mostrarCargando = false;
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
  }
}
